<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        class="pb-0 pt-0"
      >
        <!-- Toolbar -->
        <v-toolbar
          flat
          text
          height="88px"
        >
          <v-icon left>
            {{ $appConfig.api.icon }}
          </v-icon>
          <v-toolbar-title>API : "{{ api.name }}"</v-toolbar-title>
          <v-spacer />
          <span class="font-weight-bold mr-1">Status : {{ (api.enabled ? "enabled" : "disabled") }}</span>
          <v-col cols="1">
            <v-switch
              v-model="api.enabled"
              right
              :disabled="api.user_permissions !== 'owner_api'"
              color="accent"
              hide-details
              @change="changeStatus()"
            />
          </v-col>
        </v-toolbar>
        <!-- Toolbar end -->
      </v-col>

      <v-col cols="12">
        <!-- tabs START -->
        <v-tabs
          v-model="activeTab"
          background-color="grey lighten-3"
          grow
        >
          <v-tab
            v-for="(item, index) in menuItems"
            :key="index"
            ripple
          >
            {{ item.value }}
          </v-tab>
          <v-tab-item
            v-for="(item, index) in menuItems"
            :key="index"
          >
            <template v-if="item.value === 'home'">
              <api-home
                :api="api"
              />
            </template>
            <template v-else-if="item.value === 'integration'">
              <api-integration
                :api="api"
                :tabs="tabs"
                :code-to-copy-prop="codeToCopy"
                :current-language-prop="currentLanguage"
                :current-action-prop="currentAction"
                @changeLanguage="changeLanguage"
                @changeAction="changeAction"
              />
            </template>
            <template v-else-if="item.value === 'trigger'">
              <api-trigger
                ref="api-trigger"
                :api="api"
                :search="search"
                :selected-items="selectedItems"
                @deleteTrigger="deleteTrigger"
                @searchHandler="searchHandler"
                @selectedItemsHandler="selectedItemsHandler"
              />
            </template>
            <template v-else-if="item.value === 'permission'">
              <api-permissions
                :api="api"
                :my-jumbotron="myJumbotron"
                @modifyPermissions="modifyPermissions"
              />
            </template>
            <template v-else-if="item.value === 'monitoring'">
              <api-monitoring
                :api="api"
                :metrics="metrics"
                @refreshMonitoringData="refreshMonitoringData"
              />
            </template>
            <template v-else-if="item.value === 'settings'">
              <api-settings
                :api="api"
                :is-new="false"
                :labels-prop="labels"
                @delete="$emit('delete')"
              />
            </template>
          </v-tab-item>
        </v-tabs>
        <!-- tabs END -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ApiService from './services/ApiService'
  import ApiSettings from './ApiCreateUpdate.vue'
  import ApiPermissions from './ApiPermissions.vue'
  import ApiTrigger from './ApiTrigger.vue'
  import ApiHome from './ApiHome.vue'
  import ApiIntegration from './ApiIntegration.vue'
  import ApiMonitoring from './ApiMonitoring.vue'
  import NewJumbotron from '../../../UIComponents/Jumbotron.vue'
  import HmdService from '../../../UIComponents/services/HmdService'

  export default {
    components: {
      ApiSettings,
      ApiPermissions,
      ApiIntegration,
      ApiTrigger,
      ApiHome,
      ApiMonitoring,
      NewJumbotron,
    },
    props: {
      identifier: {
        type: String,
        default: null,
      },
    },
    data: function () {
      return {
        api: {},
        activeTab: 0,
        menuItems: [],
        myJumbotron: {
          type: 'accessRequest',
          heading: "You don't have access to this API",
          subHeading: 'Ask the owner to give you the permissions to access this API. They include :',
          elementList: [
            { text: 'View - TO DEFINE' },
            { text: 'Edit - TO DEFINE' },
            { text: 'Manage - TO DEFINE' },
          ],
          dividerHeading: 'Ask for an access now!',
        },
        search: '',
        selectedItems: 'All',
        metrics: {},
        labels: [],
        tabs: {},
        codeToCopy: '',
        currentLanguage: '',
        currentAction: '',
      }
    },
    watch: {
      activeTab: function () {
        this.loadTab(this.activeTab)
      },
    },
    mounted: function () {
      ApiService.get(this.identifier || this.$route.params.api)
        .then(result => {
          this.api = result.data
          if (typeof (this.api.user_permissions) !== 'undefined' && this.api.user_permissions.length > 0) {
            this.api.user_permissions = this.api.user_permissions[0]
          } else {
            this.api.user_permissions = 'none'
          }
          // TODO: this part can be re-written in a more elegant manner
          if (this.api.user_permissions !== 'owner_api') {
            this.menuItems = [
              { value: 'home', loaded: false },
              { value: 'integration', loaded: false },
              { value: 'trigger', loaded: false },
              { value: 'permission', loaded: false },
            ]
          } else {
            this.menuItems = [
              { value: 'home', loaded: false },
              { value: 'integration', loaded: false },
              { value: 'trigger', loaded: false },
              { value: 'permission', loaded: false },
              { value: 'monitoring', loaded: false },
              { value: 'settings', loaded: false },
            ]
          }
          this.loadTab(this.activeTab)
        })
    },
    methods: {
      loadTab (activeTab) {
        var item = this.menuItems[activeTab]
        if (!item.loaded) {
          switch (item.value) {
            case 'home':
              break
            case 'integration':
              ApiService.get_api_embed(this.$route.params.api)
                .then(result => {
                  this.tabs = result.data
                  this.currentLanguage = this.tabs.languages[0].language
                  this.currentAction = this.tabs.languages[0].actions[0].name
                  this.codeToCopy = this.tabs.languages[0].actions[0].src
                })
              break
            case 'trigger':
              break
            case 'permission':
              break
            case 'monitoring':
              this.callMonitoring()
              break
            case 'settings':
              HmdService.label_list()
                .then(result => {
                  this.labels = result.data
                })
              break
            default:
              break
          }
        }
        this.menuItems[activeTab].loaded = true
      },
      changeStatus () {
        let obj = {
          name: this.api.name,
          enabled: this.api.enabled,
        }
        ApiService.update(obj, this)
      },
      deleteTrigger (trigger) {
        this.api.triggers = this.api.triggers.filter(function (el) {
          return el.id !== trigger.id
        })
      },
      modifyPermissions (myObject) {
        if (myObject.type === 'deletePermission') {
          this.api.permissions = this.api.permissions.filter(function (el) {
            return el.username !== myObject.user.username
          })
        } else if (myObject.type === 'addPermission') {
          this.api.permissions.push({
            username: myObject.user,
            perms: myObject.permission,
          })
        } else if (myObject.type === 'changePermission') {
          let currUser = this.api.permissions.findIndex(x => x.username === myObject.user)
          this.api.permissions[currUser].perms = myObject.permission
        }
      },
      searchHandler: function (search) {
        this.search = search
      },
      selectedItemsHandler: function (selectedItems) {
        this.selectedItems = selectedItems
      },
      updateLoadedPages (updatedComponent) {
        switch (updatedComponent) {
          case 'schema':
            this.menuItems.find(x => x.value === 'browser').loaded = false
            break
          default:
            break
        }
      },
      callMonitoring (refresh = false) {
        ApiService.getMetrics(this, this.$route.params.name, refresh)
          .then(result => {
            this.metrics = result.data
            var count = 0
            for (var k in this.metrics) {
              this.metrics[k].options = {
                'responsive': true,
                'maintainAspectRatio': false,
                'title': {
                  'display': true,
                  'text': this.metrics[k].name,
                },
                'legend': {
                  'display': true,
                  'position': 'right',
                },
              }
              if (this.metrics.hasOwnProperty(k)) {
                for (var j in this.metrics[k].graph_data.datasets) {
                  this.metrics[k].graph_data.datasets[j].fill = false
                  this.metrics[k].graph_data.datasets[j].backgroundColor = this.$appConfig.graphColors[(count + j) % this.$appConfig.graphColors.length].backgroundColor
                  this.metrics[k].graph_data.datasets[j].borderColor = this.$appConfig.graphColors[(count + j) % this.$appConfig.graphColors.length].borderColor
                }
                ++count
              }
            }
          })
      },
      refreshMonitoringData () {
        this.callMonitoring(true)
      },
      changeAction (action) {
        this.currentAction = action
        this.changeCodeToCopy()
      },
      changeLanguage (language) {
        this.currentLanguage = language
        this.changeCodeToCopy()
      },
      changeCodeToCopy () {
        var myLanguageObject = this.tabs.languages.find(x => x.language === this.currentLanguage)
        var myActionObject = myLanguageObject.actions.find(x => x.name === this.currentAction)
        this.codeToCopy = myActionObject.src
      },
    },
  }
</script>
